import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
export var CONFIG_ACTIONS;
(function (CONFIG_ACTIONS) {
    CONFIG_ACTIONS["REQUEST"] = "GET_CONFIG_REQUEST";
    CONFIG_ACTIONS["SUCCESS"] = "GET_CONFIG_SUCCESS";
    CONFIG_ACTIONS["ERROR"] = "GET_CONFIG_ERROR";
})(CONFIG_ACTIONS || (CONFIG_ACTIONS = {}));
export function getConfigSuccessAction(data) {
    return {
        type: CONFIG_ACTIONS.SUCCESS,
        data
    };
}
export function fetchConfigAction(requestHeaders) {
    return (dispatch) => {
        dispatch({
            type: CONFIG_ACTIONS.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/3/resource/desktop/appConfigs',
            action: CONFIG_ACTIONS.REQUEST,
            headers: Object.assign({}, headers, requestHeaders),
            acceptErrors: true,
            fk_api_timeout: __SERVER__ ? 4000 : baseAjaxConfig.fk_api_timeout
        }), {}).then(json => {
            dispatch({
                type: CONFIG_ACTIONS.SUCCESS,
                data: json.RESPONSE
            });
            return json;
        }, err => {
            dispatch({
                type: CONFIG_ACTIONS.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
